<template>
  <div :class="elementClass">
    <div :class="[{ root: isRoot }]">
      <div v-if="isRoot" style="line-height: 24px; padding-left: 16px; font-size: 10px;" class="color-grey-600">
        {{ text }}
      </div>
      <div :class="[{ scrollBarHeight: isRoot }]">
        <mad-scrollbar v-if="isRoot">
          <mad-list style="height: 100%">
            <div v-for="item in data" :key="item.id">
              <subtree
                :disabledItem="disabledItem"
                :disabled="disabled"
                :root="isRoot ? rootElement : root"
                ref="subtree"
                :value="value"
                :item="item"
              ></subtree>
            </div>
          </mad-list>
        </mad-scrollbar>
        <mad-list v-else>
          <div v-for="item in data" :key="item.id">
            <subtree
              :disabledItem="disabledItem"
              :disabled="disabled"
              :root="isRoot ? rootElement : root"
              ref="subtree"
              :value="value"
              :item="item"
            ></subtree>
          </div>
        </mad-list>
      </div>
    </div>
  </div>
</template>

<script>
import Subtree from "./SubTree";
import { treeClass } from "../prefix";
export default {
  components: {
    Subtree,
  },
  props: {
    data: {},
    value: {},
    isRoot: {
      default: true,
    },
    root: {
      default: null,
    },
    text: {
      type: String,
      default: "Location Tree",
    },
    multiSelect: {
      type: Boolean,
      default: false,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    disabledItem: {
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      rootElement: this,
      currentSelectedElement: null,
      MultiData: [],
    };
  },
  methods: {
    recursiveChild(subtree, array, val = true) {
      let returnVal = null;
      subtree.forEach(sub => {
        returnVal = sub.item.id;
        sub.internalValue = val;
        if (sub.$refs.tree.$refs.subtree) {
          this.recursiveChild(sub.$refs.tree.$refs.subtree, array, val);
        }
      });
      return returnVal;
    },
    addValue(value, el) {
      if (!this.multiSelect) {
        if (this.currentSelectedElement && this.currentSelectedElement !== el) this.currentSelectedElement.internalValue = false;
        this.currentSelectedElement = el;
        this.MultiData.push(value);
        this.$emit("input", this.MultiData);
      } else {
        let array = [];
        let returnVal = this.recursiveChild([el], array);
        this.MultiData.push(returnVal);
        this.$emit("input", this.MultiData);
      }
    },
    removeValue(value, el) {
      if (!this.multiSelect) {
        this.value.forEach((item, index) => {
          if (item === el.item.id) {
            this.MultiData.splice(index, 1);
          }
        });
        this.$emit("input", this.MultiData);
      } else {
        let array = [];
        let returnVal = this.recursiveChild([el], array, false);
        this.MultiData.forEach((item, index) => {
          if (item === returnVal) {
            this.MultiData.splice(index, 1);
          }
        });
        this.$emit("input", this.MultiData);
      }
    },
  },
  watch: {
    value(val) {
      setTimeout(() => {
        if (this.$refs.subtree) {
          this.$refs.subtree.forEach((item, index) => {
            this.$refs.subtree[index].internalValue = val.includes(this.$refs.subtree[index].item.id);
          });
        }
      }, 50);
    },
  },
  computed: {
    elementClass() {
      return treeClass;
    },
  },
};
</script>

<style lang="scss">
@import "../scss/import.scss";
.mad-tree {
  @include transition(all 0.25s $animation-deceleration-curve-timing-function);
  .main-text {
    width: calc(100% - 40px);
  }

  .mad-list.has-parent .mad-list-item {
    padding: 0;
  }

  .root {
    border: 1px solid #eee;
    margin-bottom: 19px;
  }

  .scrollBarHeight {
    height: 338px;
  }

  .first-icon {
    & > * {
      @include transition(all 0.2s $animation-deceleration-curve-timing-function);
      @include transform(rotate(90deg));

      &.open {
        @include transform(rotate(0deg));
      }
    }
  }
}
</style>
